/**
 * Created by torstenzwoch on 28.06.16.
 */

import {Injectable} from '@angular/core';

@Injectable()
export class UuidService {
    constructor() {
    }

    public generateUUID(): string {
        let d = new Date().getTime();
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }
}
